import React from 'react';
import { Drawer, Button, CircularProgress } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';

const UploadProgressPanel = ({ open, uploadQueue, onClose }) => {
    const activeCount = uploadQueue.filter(item => item.status === 'uploading' || item.status === 'pending').length;
    return (
        <Drawer anchor='right' open={open} onClose={onClose} PaperProps={{ style: { width: 340 } }}>
            <div className='upload-progress-panel'>
                <div className='upload-progress-head'>
                    <h4>{activeCount ? `Uploading ${activeCount} File(s)` : 'Upload Complete'}</h4>
                    <Button size='small' color='primary' variant='outlined' onClick={onClose}>Hide</Button>
                </div>
                <div className='upload-progress-body'>
                    {uploadQueue.map(item =>
                        <div className={`upload-progress-item ${item.status === 'error' ? 'error' : ''}`} key={item.id}>
                            <span className='upload-section-name'>{item.sectionName}</span>
                            <div className='upload-item-info'>
                                <span className='upload-file-name' title={item.fileName}>{item.fileName}</span>
                                <span className='upload-status-icon'>
                                    {item.status === 'success' ? <CheckCircleIcon style={{ color: '#3aab54' }} /> :
                                        item.status === 'error' ? <ErrorIcon style={{ color: '#c62d42' }} /> :
                                            item.status === 'uploading' ? <CircularProgress size={20} thickness={5} /> :
                                                <HourglassEmptyIcon style={{ color: '#9e9e9e' }} fontSize='small' />}
                                </span>
                            </div>
                            {item.status === 'pending' && <span className='upload-status-text'>Waiting to upload...</span>}
                        </div>
                    )}
                </div>
            </div>
        </Drawer>
    )
}
export default UploadProgressPanel;
